<template>
  <div>
    <input type="file" style="display:none" ref="hiddenFileInput" @change="uploadFileChange" />
    <a-button-group style="width: 100%">
      <a-button style="width: 100%;text-align: left" @click="viewOrDownloadFile">
        <a style="text-decoration: underline">{{localValue.name}}</a>
      </a-button>
      <a-button :disabled="disabled" v-show="localValue.name&&!disabled" type="danger" icon="delete" @click="deleteFile"/>
      <a-button :disabled="disabled" type="primary" icon="upload" :loading="iconLoading" @click="choiceImg">
        上传
      </a-button>
    </a-button-group>
  </div>
</template>

<script>
import isImage from 'is-image'
import {upload} from '../../../api/api'
export default {
    name: "AExtUpload",
    props:{
        disabled:{
            type:Boolean,
            default:false
        },
        belongId:{
            type:String,
            default: ''
        },
        belongType:{
            type:String,
            default:''
        },
        belongSmallType:{
            type:String,
            default:''
        }
    },
    data(){
      return{
          localValue:{
              id:'',
              name:'',
              realName:'',
              size:0,
              suffix:'',
              creator:'',
              createTime:'',
              belongId:'',
              belongType:'',
              belongSmallType:''
          },
          iconLoading:false
      }
    },
    methods: {
        choiceImg() {
            this.$refs.hiddenFileInput.dispatchEvent(new MouseEvent('click'))
        },
        uploadFileChange(){
            if(this.$refs.hiddenFileInput.files[0].name.toLowerCase().indexOf('.pdf')===-1
                &&this.$refs.hiddenFileInput.files[0].name.toLowerCase().indexOf('.jpg')===-1
                &&this.$refs.hiddenFileInput.files[0].name.toLowerCase().indexOf('.png')===-1)
            {
                this.$message.warn('仅允许上传图片或pdf，请将文件先转换为pdf再进行上传!');
                return;
            }
            this.iconLoading=true;
            upload({belongId:this.belongId,belongType:this.belongType,belongSmallType:this.belongSmallType,file:this.$refs.hiddenFileInput.files[0]}).then(result=>{
                if (result.data&&result.data.succ)
                {
                    let resultData=result.data.data;
                    this.localValue=resultData;

                }
                this.iconLoading=false;
                this.$refs.hiddenFileInput.value = '';
            }).catch(()=>{
                this.iconLoading=false;
                this.$refs.hiddenFileInput.value = '';
            })
        },
        deleteFile()
        {
            this.localValue={
                id:'',
                name:'',
                realName:'',
                size:0,
                suffix:'',
                creator:'',
                createTime:'',
                belongId:'',
                belongType:'',
                belongSmallType:''
            }
        },
        viewOrDownloadFile()
        {
            if (isImage(this.localValue.name))
            {
                //TODO:预览图片
                this.$plugins.preview(this.localValue.id,this.localValue.suffix)
            }
            if (this.url)
            {

            }
        }
    }
}
</script>

<style scoped>

</style>